import type { CollectionEntityDefinition } from '@gzl10/nexus-sdk'
import { useIdField, useTextField, useSelectField, useDatetimeField, useNumberField } from '@gzl10/nexus-sdk/fields'

export const fileAttachmentsEntity: CollectionEntityDefinition = {
  type: 'collection',
  table: 'file_attachments',
  expose: false,
  label: { en: 'File Attachment', es: 'Archivo adjunto' },
  labelPlural: { en: 'File Attachments', es: 'Archivos adjuntos' },
  labelField: 'entity_type',
  timestamps: false,

  fields: {
    id: useIdField(),
    file_id: useSelectField({
      label: { en: 'File', es: 'Archivo' },
      table: 'storage_files',
      endpoint: '/storage/files',
      onDelete: 'CASCADE',
      required: true,
      index: true
    }),
    entity_type: useTextField({
      label: { en: 'Entity Type', es: 'Tipo de entidad' },
      required: true,
      size: 100,
      index: true
    }),
    entity_id: useTextField({
      label: { en: 'Entity ID', es: 'ID de entidad' },
      required: true,
      size: 26,
      index: true
    }),
    sort_order: useNumberField({
      label: { en: 'Sort Order', es: 'Orden' },
      nullable: true
    }),
    created_at: useDatetimeField({
      label: { en: 'Created At', es: 'Creado el' }
    })
  },

  indexes: [
    { columns: ['file_id', 'entity_type', 'entity_id'], unique: true },
    { columns: ['entity_type', 'entity_id'] }
  ],

  casl: {
    subject: 'StorageFileAttachment',
    permissions: {
      EDITOR: { actions: ['manage'] },
      USER: { actions: ['create', 'read', 'delete'] },
      VIEWER: { actions: ['read'] }
    }
  }
}
